import {useState} from 'react'
import {Button} from '@/components/ui/button/Button'
import {SlashCircle01Icon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {Access} from '../../types'
import {useDiscardAccesses} from '../../queries/useDiscardAccesses'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {toast} from '@/utilities/toast/toast'
import {DiscardAccessConfirmModal} from './DiscardAccessConfirmModal'

export const DiscardAccessButton = ({
    accessesToDiscard,
    onSuccess
}: {
    accessesToDiscard: Access[]
    onSuccess?: () => void
}) => {
    const {t} = useTranslation()
    const [isConfirmOpen, setIsConfirmOpen] = useState(false)
    const {mutate: discardAccesses, isPending} = useDiscardAccesses({
        onSuccess: () => {
            toast.success(t('accesses:access_discarded_success', {count: accessesToDiscard.length}))
            setIsConfirmOpen(false)
            onSuccess?.()
        }
    })

    const discardableAccesses = accessesToDiscard.filter(
        access => access.status === 'to_validate' || access.status === 'validated'
    )

    if (discardableAccesses.length === 0) return null

    return (
        <>
            <Button variant="ghost" size="sm" disabled={isPending} onClick={() => setIsConfirmOpen(true)}>
                {isPending ? <Spinner /> : <SlashCircle01Icon />}
                {t('accesses:discard_access', {count: discardableAccesses.length})}
            </Button>
            {isConfirmOpen && (
                <DiscardAccessConfirmModal
                    count={discardableAccesses.length}
                    isPending={isPending}
                    onClose={() => setIsConfirmOpen(false)}
                    onConfirm={() => discardAccesses({accessIds: discardableAccesses.map(access => access.id)})}
                />
            )}
        </>
    )
}
